"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.definableExists = void 0;
const getDefinables_1 = require("./getDefinables");
const definableExists = (
// eslint-disable-next-line @typescript-eslint/no-explicit-any -- The args are not relevant to this function.
prototype, id) => (0, getDefinables_1.getDefinables)(prototype).has(id);
exports.definableExists = definableExists;
